import React, { Component, Fragment, ReactNode } from "react";
import { Route, Switch } from "react-router-dom";
import {
  TabsWrapper,
  RouterNav,
  RouterList,
  RouterItem,
  TabText,
} from "./styles/tabs-styles";
import JobPerformance from "./JobPerformance/JobPerformance";
import CustomNavLink from "./CustomNavLink"; // Import the custom NavLink
import PSLPerformance from "./PSLPerformance/Index";
import FilterMain from "./Filters/FilterMain";
interface EmployerAnalyticsProps {
  currencySymbol: string;
}

class Tabs extends Component<EmployerAnalyticsProps> {
  render(): ReactNode {
    const { currencySymbol } = this.props;

    return (
      <TabsWrapper>
        <Fragment>
          <RouterNav id="tab-nav">
            <FilterMain />
            <RouterList>
              <RouterItem>
                <CustomNavLink
                  to={["/activity-overview", "/"]}
                  exact
                  activeClassName="active"
                  id="activity-overview-link"
                >
                  <TabText>Activity Overview</TabText>
                </CustomNavLink>
              </RouterItem>
              <RouterItem>
                <CustomNavLink
                  to="/psl-performance"
                  exact
                  activeClassName="active"
                  id="psl-performance-link"
                >
                  <TabText>PSL Performance</TabText>
                </CustomNavLink>
              </RouterItem>
            </RouterList>
          </RouterNav>
          <Switch>
            <Route
              exact
              path="/"
              component={() => (
                <JobPerformance currencySymbol={currencySymbol} />
              )}
            />
            <Route
              exact
              path="/activity-overview"
              component={() => (
                <JobPerformance currencySymbol={currencySymbol} />
              )}
            />
            <Route
              exact
              path="/psl-performance"
              component={() => <PSLPerformance />}
            />
          </Switch>
        </Fragment>
      </TabsWrapper>
    );
  }
}

export default Tabs;
